import { useSearchParams } from 'next/navigation'

import type { UserForRole } from '../helpers/authentication'

import { getRoleFlags } from '../helpers/authentication'
import useUser from './useUser'

export default function useRole<T extends UserForRole>() {
  const searchParams = useSearchParams()
  const { isLoading, user } = useUser<T>()

  return {
    isLoading,
    ...getRoleFlags<T>(user, searchParams),
  }
}
